import { useCallback, useState } from 'react';
import { getUpdateReamPalletGrossWeight } from '../services/productionService';

const useUpdateReamPalletGrossWeight = (callMessage) => {
    const [updateApproveList,setUpdateAppeovedList]=useState([]);
    const processIndent = useCallback(async (requestBody) => {
        try {                   

            // Await the API response
            const data = await getUpdateReamPalletGrossWeight(requestBody);
            
            if (data?.length > 0) {
                setUpdateAppeovedList(data);
                callMessage('info', 'Ream pallet gross weight updated successfully', 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent,updateApproveList,setUpdateAppeovedList };
};

export default useUpdateReamPalletGrossWeight;

